import { createPortal } from 'react-dom';

import { clsx } from 'clsx';

export const AiDrawer = ({ isMounted, isVisible, isFullscreen, children, topBar, sidebar, onBackdropClick }) => {
    if (!isMounted) return null;
    return createPortal(
        <div
            className={clsx(
                'fixed inset-0 z-[3147483000] flex justify-end',
                isVisible ? 'pointer-events-auto' : 'pointer-events-none'
            )}
        >
            <button
                type='button'
                onClick={onBackdropClick}
                className={clsx(
                    'absolute inset-0 m-0 cursor-pointer border-none p-0 transition-opacity duration-300',
                    'bg-slate-950/45',
                    isVisible ? 'opacity-100' : 'opacity-0'
                )}
            />
            <div
                className={clsx(
                    'relative flex h-full max-w-full flex-col',
                    'shadow-[0_26px_70px_rgba(2,6,23,0.38)] transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] will-change-transform',
                    isVisible ? 'translate-x-0' : 'translate-x-full',
                    isFullscreen ? 'w-screen' : 'w-[38vw] min-w-[480px] max-w-[780px]'
                )}
            >
                {topBar}
                <div className='flex flex-1 overflow-hidden'>
                    {isFullscreen && sidebar && <div className='w-[280px] shrink-0'>{sidebar}</div>}
                    <div className='flex flex-1 flex-col bg-gray-100 overflow-hidden'>{children}</div>
                </div>
            </div>
        </div>,
        document.body
    );
};
